module.exports = __webpack_public_path__ + "img/map.40f4efe8.webp";